module.exports = __webpack_public_path__ + "img/PW1.64592fb8.jpg";